module.exports = __webpack_public_path__ + "img/sgyl.dc022996.png";